import { ObservableArray, View } from "binder"
import { DataModelBuilderViewModel, DataModelClass } from "./dataModelBuilder-viewModel"

export class DataModelBuilderView extends View<DataModelBuilderViewModel>{
    GetViewUniqueId(): string {
        return "V-A5F757E8-74A7-45DF-BBE9-559E36317FE4"
    }
    loadHtml(): string {
        let element = require('./dataModelBuilder.html').default;
        let style = require('./dataModelBuilder.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set classes(v: ObservableArray<DataModelClass>) { this._classes = v; } public get classes(): ObservableArray<DataModelClass> { return this._classes;} private _classes: ObservableArray<DataModelClass>;

    
    addNewClass(){
        this.dataContext.addNewClass();
    }
    getDataModelJson(){
        this.dataContext.getDataModelJson();
    }

    save(){
        this.dataContext.save();
    }

    export(){
        this.dataContext.export();
    }
    import(){
        this.dataContext.import();
    }
    edit(){
        this.dataContext.edit();
    }
}
